import * as React from 'react';

import TapNovelWebView from '../../shared/TapNovelWebView';
import Layout from '../../shared/Layout';

import NavigationProp from '../../../navigators/NavigationProp';
import {PoliciesPrivacyRouteProp} from '../../../navigators/RouteProps';

import {getUserAgent} from '../../../../data/data_stores/net/UserAgent';

export interface Params {}

export interface StateProps {
  navigation: NavigationProp;
  route: PoliciesPrivacyRouteProp;
}

export interface DispatchProps {}

interface Props extends StateProps, DispatchProps {
  children?: React.ReactNode;
}

const Index: React.FunctionComponent<Props> = props => {
  const {navigation, route} = props;
  const back = route.name === 'PoliciesPrivacy';
  const close = route.name !== 'PoliciesPrivacy';
  const [userAgent, setUserAgent] = React.useState<string | null>(null);
  React.useEffect(() => {
    getUserAgent().then(ua => {
      setUserAgent(ua);
    });
  });
  return (
    <Layout
      title={'プライバシーポリシー'}
      scrollable={false}
      navigation={navigation}
      back={back}
      close={close}>
      {userAgent && (
        <TapNovelWebView
          style={{flex: 1}}
          originWhitelist={['*']}
          path={'/policies/privacy?without_layout=on'}
          userAgent={userAgent}
        />
      )}
    </Layout>
  );
};

const areEqual = (prevProps: Readonly<Props>, nextProps: Readonly<Props>) => {
  return true;
};

export default React.memo(Index, areEqual);
